import { useRef, useState } from "react";
import { images } from "@img/imagesMap";
import LoadingDots from "@components/LoadingDots";

interface ExcelUploadTemplateProps {
  title: string;
  templateUrl?: string;
  templateFileName?: string;
  onDownloadTemplate?: () => void;
  onFileUpload: (file: File) => void;
  isUpload: boolean;
  excelFileName?: string;
  children?: React.ReactNode;
}

export default function ExcelUploadTemplate({
  title,
  templateUrl,
  templateFileName,
  onDownloadTemplate,
  onFileUpload,
  isUpload,
  excelFileName,
  children,
}: ExcelUploadTemplateProps) {
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  function clickUploadButton() {
    fileInputRef.current?.click();
  }

  return (
    <>
      <h3 className="font-pretendard font-semibold text-2xl text-sig mb-4">
        {title}
      </h3>
      <div className="comp_table comp_table--mgmtMworks">
        <div className="excel_modal_body">
          <div className="excel_dargArea_container flex flex-col items-start">
            {onDownloadTemplate ? (
              <button
                type="button"
                className="excel_template_download mb-3! flex items-center justify-center gap-2"
                onClick={onDownloadTemplate}
              >
                <img src={images.icon_excel} alt="" />
                {title} 템플릿 다운로드
              </button>
            ) : (
              <a
                href={templateUrl}
                download={templateFileName}
                className="excel_template_download mb-3! flex items-center justify-center gap-2"
              >
                <img src={images.icon_excel} alt="" />
                {title} 템플릿 다운로드
              </a>
            )}

            <div
              className={`excel_upload_dragArea ${
                isDragging ? "excel_upload_dragArea--dragging" : ""
              }`}
              onDragOver={(e) => {
                e.preventDefault();
                setIsDragging(true);
              }}
              onDragLeave={() => setIsDragging(false)}
              onDrop={(e) => {
                e.preventDefault();
                setIsDragging(false);

                if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
                  onFileUpload(e.dataTransfer.files[0]);
                  e.dataTransfer.clearData();
                }
              }}
            >
              <div
                className={`excel_upload_fileName ${
                  !excelFileName && "excel_upload_fileName--noFile"
                }`}
              >
                {excelFileName
                  ? excelFileName
                  : "파일을 여기로 끌어오거나 파일선택 버튼을 눌러 등록해주세요"}
              </div>
              <button
                type="button"
                className="excel_upload_button"
                onClick={clickUploadButton}
              >
                파일 선택
              </button>
            </div>
            <input
              type="file"
              className="excel_upload_inputFile"
              ref={fileInputRef}
              accept=".xlsx, .xls"
              onInput={(e) => {
                if (e.currentTarget.files && e.currentTarget.files.length > 0) {
                  onFileUpload(e.currentTarget.files[0]);
                  fileInputRef.current!.value = "";
                }
              }}
            ></input>
          </div>
        </div>

        {/* 결과 영역 (각 탭별 상이한 결과 테이블 등) */}
        {children}
      </div>

      {isUpload && (
        <div className="excel_uploading_bg">
          <div>업로드 중입니다</div>
          <LoadingDots />
        </div>
      )}
    </>
  );
}
